import { render, staticRenderFns } from "./expected_student_file_form.vue?vue&type=template&id=5ea5f4a4&scoped=true&"
import script from "./expected_student_file_form.vue?vue&type=script&lang=ts&"
export * from "./expected_student_file_form.vue?vue&type=script&lang=ts&"
import style0 from "./expected_student_file_form.vue?vue&type=style&index=0&id=5ea5f4a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5f4a4",
  null
  
)

export default component.exports